/* eslint-disable no-debugger */
import { useState } from 'react';

import ClubMeetsData from './ClubMeetsData';

const useClubMeetsData = () => {
  const [clubMeetsState, setClubMeetsState] = useState(ClubMeetsData.INITIAL_STATE);
  const [clubApprovedMeetsState, setClubApprovedMeetsState] = useState(ClubMeetsData.INITIAL_STATE);

  const getClubMeets = (orgUnitId, reportPeriodId) => {
    ClubMeetsData.getClubMeetsData(orgUnitId, reportPeriodId, clubMeetsState, setClubMeetsState);
  };

  const getClubUsasSanctionedMeets = (orgUnitId, reportPeriodId, usasOrgUnitId) => {
    ClubMeetsData.getClubUsasSanctionedMeetsData(orgUnitId, reportPeriodId, usasOrgUnitId, clubMeetsState, setClubMeetsState);
  };

  const getClubApprovedMeets = (orgUnitId, reportPeriodId, usasOrgUnitId) => {
    ClubMeetsData.getClubApprovedMeetsData(orgUnitId, reportPeriodId, usasOrgUnitId, clubApprovedMeetsState, setClubApprovedMeetsState);
  };

  const postMeetSanctionRequest = (descOfMedSup, requestSig, meetSanctionRequest) => {
    ClubMeetsData.postClubMeetSanctionRequestData(descOfMedSup, requestSig, meetSanctionRequest, clubMeetsState, setClubMeetsState);
  };

  const putMeetSanctionRequest = (meetId, meetSanctionRequestId, descOfMedSup, requestSig, meetSanctionRequest) => {
    ClubMeetsData.putClubMeetSanctionRequestData(meetId, meetSanctionRequestId, descOfMedSup, requestSig, meetSanctionRequest, clubMeetsState, setClubMeetsState);
  }

  const postApprovedMeetRequest = (meetObj) => {
    ClubMeetsData.postApprovedMeetData(meetObj, clubApprovedMeetsState, setClubApprovedMeetsState);
  };

  const putApprovedMeetRequest = (meetId, meetApprovalRequestId, meetObj) => {
    ClubMeetsData.putApprovedMeetData(meetId, meetApprovalRequestId, meetObj, clubApprovedMeetsState, setClubApprovedMeetsState);
  };

  const deleteClubMeet = (meetId) => {
    ClubMeetsData.deleteMeetData(meetId, clubMeetsState, setClubMeetsState);
  };

  const clearObjData = () => {
    setClubMeetsState({
      ...clubMeetsState,
      isObjLoading: false,
      isObjLoaded: false,
      isSaving: false,
      isSaved: false,
      objData: {}
    });
  };

  const clearClubApprovedMeetsObjData = () => {
    setClubApprovedMeetsState({
      ...clubApprovedMeetsState,
      isObjLoading: false,
      isObjLoaded: false,
      isSaving: false,
      isSaved: false,
      objData: {}
    });
  };

  const clearArrayData = () => {
    setClubMeetsState({
      ...clubMeetsState,
      isArrayLoading: false,
      isArrayLoaded: false,
      isSaving: false,
      isSaved: false,
      arrayData: []
    });
  };

  const clearClubApprovedMeetsArrayData = () => {
    setClubApprovedMeetsState({
      ...clubApprovedMeetsState,
      isArrayLoading: false,
      isArrayLoaded: false,
      isSaving: false,
      isSaved: false,
      arrayData: []
    });
  };

  const confirmSave = () => {
    setClubMeetsState({
      ...clubMeetsState,
      isSaved: false
    });
  };

  return {
    clubMeetsState,
    clubApprovedMeetsState,
    getClubMeets,
    getClubUsasSanctionedMeets,
    getClubApprovedMeets,
    postMeetSanctionRequest,
    putMeetSanctionRequest,
    postApprovedMeetRequest,
    putApprovedMeetRequest,
    deleteClubMeet,
    clearArrayData,
    clearClubApprovedMeetsArrayData,
    clearObjData,
    clearClubApprovedMeetsObjData,
    confirmSave
  };
};

export default useClubMeetsData;